import request from '@/utils/request'
import qs from 'qs'

export function queryAll() {
  return request({
    url: '/api-admin/role/queryAll',
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
}

export function updateRolePermissions(data) {
  return request({
    url: '/api-admin/role/updateRolePermissions',
    method: 'post',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data)
  })
}

export function queryAllPermissionRole(roleId) {
  return request({
    url: '/api-admin/permission/queryAllPermissionRole',
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    params: { roleId }
  })
}

export function getUserRoles(userId) {
  return request({
    url: '/api-admin/role/getUserRoles',
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    params: { userId }
  })
}

export function getClientRoles(clientId) {
  return request({
    url: '/api-admin/role/getClientRoles',
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    params: { clientId }
  })
}